// VNYL-1379 — A/B test: open search bar on mobile product pages.
//
// Reuses the SAME server-side A/B bucket that the cart uses (`abTestVariant` in
// localStorage, resolved by ab-test.js). For the variant bucket, the mobile
// search bar renders open by default on product pages instead of the collapsed
// icon. Also registers a dedicated Mixpanel super-property (`search_bar_test`)
// so this test can be read independently in analytics.
//
// Loaded after all.js (needs `window.app`) and after utils.js / ab-test.js.
(function () {
  var SEARCH_BAR_VARIANT_NAME = 'variant_july2026';

  function readVariantName() {
    try {
      var raw = localStorage.getItem('abTestVariant');
      var obj = raw ? JSON.parse(raw) : null;
      return obj && obj.name ? obj.name : null;
    } catch (e) {
      return null;
    }
  }

  function applyVariant(variantName) {
    // Sync-readable flag consumed by isSearchOpenDefaultUrl() in all.js.
    window.searchBarTestOpen = variantName === SEARCH_BAR_VARIANT_NAME;

    // Register the super-property so it rides along on `Search Executed`,
    // order, and every subsequent Mixpanel event for cohort splitting.
    // NOTE: `utils` is a top-level `const` in utils.js (a classic script), so it
    // lives on the shared global lexical scope, NOT as `window.utils`. Reference
    // it bare (guarded by typeof) exactly like ab-test.js does.
    try {
      if (
        typeof utils !== 'undefined' &&
        utils.mixpanelRetryWrapper &&
        typeof utils.mixpanelRetryWrapper.register === 'function'
      ) {
        utils.mixpanelRetryWrapper.register({ search_bar_test: variantName || 'control' });
      }
    } catch (e) {
      console.log('[search-bar-ab-test] register error:', e);
    }

    // Re-apply the mobile header open/collapsed state now that the bucket is
    // known. Sticky users get this synchronously on load; new users get it once
    // the server-side assignment resolves. mobileHeaderActions() is idempotent.
    try {
      if (
        window.innerWidth < 992 &&
        window.app &&
        typeof app.mobileHeaderActions === 'function'
      ) {
        app.mobileHeaderActions();
      }
    } catch (e) {
      console.log('[search-bar-ab-test] apply error:', e);
    }

    // On product pages, the open bar is mounted inside .inner (already padded by
    // .container), so add a scoped class to zero out the extra horizontal padding
    // and align the input with the page content. Scoped so the click-to-open bar
    // on other page types is untouched.
    try {
      var bar = document.getElementById('headerFormMobileSearch');
      if (bar) {
        var isPdpVariant =
          window.searchBarTestOpen === true && window.location.pathname.includes('/products');
        bar.classList.toggle('open-search-bar--pdp', isPdpVariant);
      }
    } catch (e) {
      console.log('[search-bar-ab-test] class error:', e);
    }
  }

  // 1. Returning/sticky users: bucket is already in localStorage, so the open
  //    bar can show on first paint (before the head promise resolves).
  applyVariant(readVariantName());

  // 2. New users: wait for the shared assignment, then re-apply + register.
  if (window.abTestVariantPromise && typeof window.abTestVariantPromise.then === 'function') {
    window.abTestVariantPromise
      .then(function () {
        applyVariant(readVariantName());
      })
      .catch(function () {});
  }
})();
